import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

/**
 * Passenger Info Guard
 * 
 * Bu guard, kullanıcının yolcu bilgilerini doldurmuş ve transaction başlatmış olup olmadığını kontrol eder.
 * Eğer yolcu verisi veya transactionKey yoksa, kullanıcı yolcu bilgileri sayfasına yönlendirilir.
 * 
 * Korunan sayfalar: /odeme
 */
export const passengerInfoGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);

  // URL parametrelerinden kontrol
  const transactionKeyFromUrl = route.queryParams['transactionKey'];
  
  // SessionStorage'dan kontrol
  const storedTransactionKey = sessionStorage.getItem('currentTransactionKey');
  const storedPassengerData = sessionStorage.getItem('currentPassengerData');
  
  // TransactionKey var mı?
  const hasTransactionKey = !!(transactionKeyFromUrl || storedTransactionKey);
  
  // Yolcu verisi var mı?
  const hasPassengerData = !!storedPassengerData;
  
  // Her iki koşul da sağlanıyorsa izin ver
  if (hasTransactionKey && hasPassengerData) {
    return true;
  }

  // TransactionKey var ama passenger data yoksa - bu önceki bir session olabilir
  // Yine de devam etmesine izin ver (backend hata verecektir gerekirse)
  if (hasTransactionKey) {
    return true;
  }

  // Hiçbir veri yoksa ana sayfaya yönlendir
  router.navigate(['/']);
  return false;
};
